import React from 'react';
import { useReveal } from '../lib/useReveal';
const PAIN_POINTS = ['Años sintiéndote responsable de la felicidad de tu familia', 'Una culpa constante que aparece cada vez que priorizás algo tuyo', 'Patrones que se repiten en tus relaciones sin que puedas detenerlos', 'Un techo invisible que te frena justo cuando empezás a brillar', 'La sensación de traicionar a tu linaje si te permitís tener más', 'Esperando un permiso que nunca llega para ser plenamente vos'];
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#2D1B1B] py-12 md:py-16 px-5 sm:px-6 relative overflow-hidden border-t border-[#C9A96E]/10" data-id="element-263">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-264">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-265">
          <div className="text-center mb-10" data-id="element-266">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight text-[#F5ECD7]" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-267">
              ¿Cuánto tiempo más vas a cargar lo que no es tuyo?
            </h2>
            <div className="text-lg md:text-xl text-[#FAF3E8] space-y-4 font-medium" data-id="element-268">
              <p data-id="element-269">
                Sentís algo hace tiempo. Una carga que no sabés bien de dónde
                viene. Una tristeza sin nombre. Una voz que te frena justo
                cuando algo empieza a ir bien.
              </p>
              <p data-id="element-270">
                No es que seas demasiado sensible.
                <br data-id="element-271" />
                No es que te falte fuerza de voluntad.
              </p>
              <p className="text-[#C9A96E] font-bold text-xl mt-4" data-id="element-272">
                Es que nadie te enseñó a distinguir lo que es tuyo de lo que
                heredaste.
              </p>
            </div>
          </div>

          <div className="max-w-2xl mx-auto bg-[#1C1410] border border-[#C9A96E]/20 rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-273">
            <ul className="space-y-4" data-id="element-274">
              {PAIN_POINTS.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-275">
                  <span className="text-[#C4856A] text-lg leading-none mt-0.5 flex-shrink-0" data-id="element-276">
                    ❌
                  </span>
                  <span className="text-[#FAF3E8] text-base md:text-lg leading-snug" data-id="element-277">
                    {point}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="mt-10 text-center" data-id="element-278">
            <p className="text-[#F5ECD7] font-serif italic text-xl md:text-2xl font-bold" data-id="element-279">
              ¿Y si hoy fuera el último día que cargás lo que nunca fue tuyo?
            </p>
          </div>
        </div>
      </div>
    </section>;
}